import React from 'react';
import { Cache } from 'aws-amplify';
import { Alert, Button, Modal, Table, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import '../css/layout.css';
import APIClient from './APIClient';
import { COMPANY_ADMIN, SUPER_ADMIN } from '../store/actions/users/usersActions';

export const AlertMessage = ({
    show,
    type,
    onCloseFunc,
    message
}) => {
    let alertIcon = '';
    if (type === "success") {
        alertIcon = <FontAwesomeIcon icon={faCheck} />
    }
    else {
        alertIcon = <FontAwesomeIcon icon={faExclamationCircle} />
    }

    return (
        <div className="alert-fixed">
            <Alert variant={type} show={show} onClose={ () => onCloseFunc() }>
                {alertIcon} {message}
            </Alert>
        </div>
    )
}

export const formatDate = (date, separator = '/') => {
    let formattedDate = '';
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    formattedDate = yyyy + separator + mm + separator + dd;
    
    return formattedDate;
}

export const changeDateFormat = (date) => {
    let currentDate = new Date(date);
    let formattedDate = currentDate.getFullYear() + "-" + String(currentDate.getMonth() + 1).padStart(2, '0') + "-" + String(currentDate.getDate()).padStart(2, '0');

    return formattedDate
}

export const ConfirmDialog = ({
    show, 
    onHideFunction, 
    modalTitle, 
    modalBody, 
    onClickCancel, 
    onClickConfirm, 
    specialForm = null, 
    remarksId, 
    remarksRequired = true 
}) => {

    const confirmButtonText = "Yes, Confirmed";
    const cancelButtonText  = "Nope"
    const spinner = '<span class="spinner-border spinner-border-sm"></span>'; //html of react spinner
    
    let disableConfirm = false;
    if (remarksRequired && specialForm) {
        disableConfirm = true;
        const remarks = document.getElementById(remarksId);
        const minRemarkLength = 10;
        if (remarks && remarks.value && remarks.value.length > minRemarkLength) {
            disableConfirm = false;
        }
    }

    return (
        <Modal show={show} onHide={() => {
                onHideFunction();
        }}>
            <Modal.Header>
                <Modal.Title> {modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {modalBody}
                {specialForm}
            </Modal.Body>
            <Modal.Footer>
            <Button 
                id="nopeCancel" 
                size="sm" 
                variant="secondary" 
                className="float-left" 
                onClick={() => {
                    onClickCancel();
                }
            }>
                {cancelButtonText}
            </Button>
            <Button 
                id="yesConfirm" 
                size="sm" 
                variant="primary" 
                disabled={disableConfirm}
                onClick={() => {   

                    const confirmButton = document.getElementById("yesConfirm");
                    confirmButton.disabled = true;
                    confirmButton.innerHTML = spinner;

                    const cancelButton = document.getElementById("nopeCancel");
                    cancelButton.disabled = true;
                    cancelButton.innerHTML = spinner;

                    onClickConfirm();
                }}>
                {confirmButtonText}
            </Button>
            </Modal.Footer>
        </Modal>
    )
}

/*
    tableData = {
        headerClass: 'header-class',
        headers: [
            { class: 'some-class', content: 'Header 1'},
            { class: 'some-class-again', content: 'Header 2'},
        ],
        body: [
            [
                { class: 'some-column', content: 'Column 1'},
                { class: 'some-column', content: 'Column 2'},
            ],
            [
                { class: 'some-column', content: 'Column 1 a'},
                { class: 'some-column', content: 'Column 2 a'},
            ]
        ]
    }

    OR

    tableData = {
        headerClass: 'header-class',
        headers: ['Header 1','Header 2'],
        body: [
            ['Column 1', 'Column 2'],
            ['Column 1a', 'Column 2a']
        ]
    }
*/

export const drawTable = (tableData, showTable = false, extraRow = null) => {
   
  
    if (!showTable || typeof(tableData) === "undefined") {
        return '';
    }
    
    let tableHeaders = [];
    let tableRows = [];

    if (tableData.headers && tableData.headers.length) {
        tableData.headers.forEach( (header, key) => {
            const headerClass = header.class || tableData.headerClass || '';
            const headerContent = header.content || header || '';
            tableHeaders.push(
                <th className={headerClass} key={key}>{headerContent}</th>
            )
        }) 
    }

    if (tableData.body) {
        if (tableData.body && tableData.body.length) {
            tableData.body.forEach( (row, key) => {
                let tableColumns = [];
                if (row && row.length) {
                    row.forEach( (column, key) => {
                      if (typeof(column) !== "undefined") {
                        // if (!column && !Number.isInteger(column)) {
                        //     return null;
                        // }
                        let columnClass = '';
                        let columnContent = '';

                        columnClass = column.class || tableData.headerClass || '';
                        columnContent = column.content || column;

                        tableColumns.push(
                            <td className={columnClass} key={key}>{columnContent}</td>
                        )
                      }
                    })
                }
                
                tableRows.push(
                    <tr key={key}>{tableColumns}</tr>
                )
            }) 
        }
        else {
            tableRows.push(
                <tr key="loading"><td>Loading...</td></tr>
            )
        }
    }
    else {
        tableRows.push(
            <tr key={1}>
                <td colSpan={tableData.headers.length}>No results found.</td>
            </tr>
        )
    }
    

    return (
      <>
        <Row>
          <Col>
            <Table>
                <thead>
                  <tr>
                    {tableHeaders}
                  </tr>
                </thead>
                <tbody>
                    {tableRows}
                    {extraRow ? extraRow : ''}
                </tbody>
            </Table>
          </Col>
        </Row>
      </>
    )
}

export const toMonetaryFormat = (amount) => {
    return (+amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'); //https://stackoverflow.com/a/14428340
}

export const fixedRounding = (number) => {
    return +number.toFixed(2);
}  

export const capitalize = (str) => {
    return String(str).split(" ").map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(" ")
}

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const uploadImages = async (e) => {

  const image = e?.target?.files[0] || e?.dataTransfer?.files[0] || e;
  if (!image) {
    return;
  }

  const formData = new FormData();
  formData.append("image", image);

  const response = await client().post('/file-upload/cms/upload-image', formData)
  
  return response?.data?.image_url
}


export const isCompanyAdmin = () => {
  const currentUser = Cache.getItem('userdata');

  if (typeof(currentUser) !== "undefined") {
    return currentUser?.userDetails?.roles[0]?.id === COMPANY_ADMIN
  }
}

export const isSuperAdmin = () => {
  const currentUser = Cache.getItem('userdata');
  if (typeof(currentUser) !== "undefined") {
    return currentUser?.userDetails?.roles[0]?.id === SUPER_ADMIN
  }
  return true;
}

export const isActive = () => {
  const currentUser = Cache.getItem('userdata');
  return currentUser?.userDetails?.is_disabled === 0
}
